// DO NOT EDIT -- generated from fs/services/paige/paige.proto

import * as pages from '../../api/pages';
import * as pagination from '../../shared/pagination';
import * as protobuf from '../../../google/protobuf';
import * as segment from '../../api/segment';

export namespace Cron {

  export const ComputeAllLearnedPagesEndpoint = "/grpc/paige.Cron/ComputeAllLearnedPages";
  export function ComputeAllLearnedPages(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeAllLearnedPagesEndpoint),
      endpoint: ComputeAllLearnedPagesEndpoint
    };
  }
}

export namespace Pages {

  export const GetAllEndpoint = "/grpc/paige.Pages/GetAll";
  export function GetAll(sender: (req: GetAllRequest, endpoint: string) => Promise<GetAllReply>, req: GetAllRequest): { promise: () => Promise<GetAllReply>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllEndpoint),
      endpoint: GetAllEndpoint
    };
  }

  export const GetEndpoint = "/grpc/paige.Pages/Get";
  export function Get(sender: (req: GetRequest, endpoint: string) => Promise<GetReply>, req: GetRequest): { promise: () => Promise<GetReply>, endpoint: string } {
    return {
      promise: () => sender(req, GetEndpoint),
      endpoint: GetEndpoint
    };
  }

  export const SetEndpoint = "/grpc/paige.Pages/Set";
  export function Set(sender: (req: SetRequest, endpoint: string) => Promise<SetReply>, req: SetRequest): { promise: () => Promise<SetReply>, endpoint: string } {
    return {
      promise: () => sender(req, SetEndpoint),
      endpoint: SetEndpoint
    };
  }

  export const ArchiveEndpoint = "/grpc/paige.Pages/Archive";
  export function Archive(sender: (req: ArchiveRequest, endpoint: string) => Promise<ArchiveReply>, req: ArchiveRequest): { promise: () => Promise<ArchiveReply>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveEndpoint),
      endpoint: ArchiveEndpoint
    };
  }

  export const ArchiveMultiEndpoint = "/grpc/paige.Pages/ArchiveMulti";
  export function ArchiveMulti(sender: (req: ArchiveMultiRequest, endpoint: string) => Promise<ArchiveMultiReply>, req: ArchiveMultiRequest): { promise: () => Promise<ArchiveMultiReply>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveMultiEndpoint),
      endpoint: ArchiveMultiEndpoint
    };
  }

  export const UnarchiveEndpoint = "/grpc/paige.Pages/Unarchive";
  export function Unarchive(sender: (req: UnarchiveRequest, endpoint: string) => Promise<UnarchiveReply>, req: UnarchiveRequest): { promise: () => Promise<UnarchiveReply>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveEndpoint),
      endpoint: UnarchiveEndpoint
    };
  }

  export const MatchEndpoint = "/grpc/paige.Pages/Match";
  export function Match(sender: (req: MatchRequest, endpoint: string) => Promise<MatchReply>, req: MatchRequest): { promise: () => Promise<MatchReply>, endpoint: string } {
    return {
      promise: () => sender(req, MatchEndpoint),
      endpoint: MatchEndpoint
    };
  }

  export const AutocompleteEndpoint = "/grpc/paige.Pages/Autocomplete";
  export function Autocomplete(sender: (req: AutocompleteRequest, endpoint: string) => Promise<AutocompleteReply>, req: AutocompleteRequest): { promise: () => Promise<AutocompleteReply>, endpoint: string } {
    return {
      promise: () => sender(req, AutocompleteEndpoint),
      endpoint: AutocompleteEndpoint
    };
  }

  export const SearchEndpoint = "/grpc/paige.Pages/Search";
  export function Search(sender: (req: SearchRequest, endpoint: string) => Promise<SearchReply>, req: SearchRequest): { promise: () => Promise<SearchReply>, endpoint: string } {
    return {
      promise: () => sender(req, SearchEndpoint),
      endpoint: SearchEndpoint
    };
  }

  export const SetMLStateEndpoint = "/grpc/paige.Pages/SetMLState";
  export function SetMLState(sender: (req: SetMLStateRequest, endpoint: string) => Promise<{}>, req: SetMLStateRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetMLStateEndpoint),
      endpoint: SetMLStateEndpoint
    };
  }

  export const ListPagesEndpoint = "/grpc/paige.Pages/ListPages";
  /**
   * Lists page definitions, returning a batch of records and a pagination token.
   * A sane default limit per batch is enforced if not limit is provided.
   * Results are ordered by last modified date.
   */
  export function ListPages(sender: (req: ListPagesRequest, endpoint: string) => Promise<ListPagesResponse>, req: ListPagesRequest): { promise: () => Promise<ListPagesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListPagesEndpoint),
      endpoint: ListPagesEndpoint
    };
  }

  export const MatchUrlsEndpoint = "/grpc/paige.Pages/MatchUrls";
  /** MatchUrls matches a list of URLs against page def patterns. */
  export function MatchUrls(sender: (req: MatchUrlsRequest, endpoint: string) => Promise<MatchUrlsReply>, req: MatchUrlsRequest): { promise: () => Promise<MatchUrlsReply>, endpoint: string } {
    return {
      promise: () => sender(req, MatchUrlsEndpoint),
      endpoint: MatchUrlsEndpoint
    };
  }

  export const ReservePageIdsEndpoint = "/grpc/paige.Pages/ReservePageIds";
  /** ReservePageIds fetches and increments page ids so they are effectively reserved */
  export function ReservePageIds(sender: (req: ReservePageIdsRequest, endpoint: string) => Promise<ReservePageIdsResponse>, req: ReservePageIdsRequest): { promise: () => Promise<ReservePageIdsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ReservePageIdsEndpoint),
      endpoint: ReservePageIdsEndpoint
    };
  }

  export const SetManyEndpoint = "/grpc/paige.Pages/SetMany";
  export function SetMany(sender: (req: SetManyRequest, endpoint: string) => Promise<SetManyReply>, req: SetManyRequest): { promise: () => Promise<SetManyReply>, endpoint: string } {
    return {
      promise: () => sender(req, SetManyEndpoint),
      endpoint: SetManyEndpoint
    };
  }
}

export namespace PagesPublic {

  export const GetAllEndpoint = "/grpc/paige.PagesPublic/GetAll";
  export function GetAll(sender: (req: GetAllRequest, endpoint: string) => Promise<GetAllReply>, req: GetAllRequest): { promise: () => Promise<GetAllReply>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllEndpoint),
      endpoint: GetAllEndpoint
    };
  }

  export const GetEndpoint = "/grpc/paige.PagesPublic/Get";
  export function Get(sender: (req: GetRequest, endpoint: string) => Promise<GetReply>, req: GetRequest): { promise: () => Promise<GetReply>, endpoint: string } {
    return {
      promise: () => sender(req, GetEndpoint),
      endpoint: GetEndpoint
    };
  }

  export const SetEndpoint = "/grpc/paige.PagesPublic/Set";
  export function Set(sender: (req: SetRequest, endpoint: string) => Promise<SetReply>, req: SetRequest): { promise: () => Promise<SetReply>, endpoint: string } {
    return {
      promise: () => sender(req, SetEndpoint),
      endpoint: SetEndpoint
    };
  }

  export const ArchiveEndpoint = "/grpc/paige.PagesPublic/Archive";
  export function Archive(sender: (req: ArchiveRequest, endpoint: string) => Promise<ArchiveReply>, req: ArchiveRequest): { promise: () => Promise<ArchiveReply>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveEndpoint),
      endpoint: ArchiveEndpoint
    };
  }

  export const ArchiveMultiEndpoint = "/grpc/paige.PagesPublic/ArchiveMulti";
  export function ArchiveMulti(sender: (req: ArchiveMultiRequest, endpoint: string) => Promise<ArchiveMultiReply>, req: ArchiveMultiRequest): { promise: () => Promise<ArchiveMultiReply>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveMultiEndpoint),
      endpoint: ArchiveMultiEndpoint
    };
  }

  export const UnarchiveEndpoint = "/grpc/paige.PagesPublic/Unarchive";
  export function Unarchive(sender: (req: UnarchiveRequest, endpoint: string) => Promise<UnarchiveReply>, req: UnarchiveRequest): { promise: () => Promise<UnarchiveReply>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveEndpoint),
      endpoint: UnarchiveEndpoint
    };
  }

  export const AutocompleteEndpoint = "/grpc/paige.PagesPublic/Autocomplete";
  export function Autocomplete(sender: (req: AutocompleteRequest, endpoint: string) => Promise<AutocompleteReply>, req: AutocompleteRequest): { promise: () => Promise<AutocompleteReply>, endpoint: string } {
    return {
      promise: () => sender(req, AutocompleteEndpoint),
      endpoint: AutocompleteEndpoint
    };
  }

  export const SearchEndpoint = "/grpc/paige.PagesPublic/Search";
  export function Search(sender: (req: SearchRequest, endpoint: string) => Promise<SearchReply>, req: SearchRequest): { promise: () => Promise<SearchReply>, endpoint: string } {
    return {
      promise: () => sender(req, SearchEndpoint),
      endpoint: SearchEndpoint
    };
  }

  export const SetMLStateEndpoint = "/grpc/paige.PagesPublic/SetMLState";
  export function SetMLState(sender: (req: SetMLStateRequest, endpoint: string) => Promise<{}>, req: SetMLStateRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetMLStateEndpoint),
      endpoint: SetMLStateEndpoint
    };
  }

  export const MatchUrlsEndpoint = "/grpc/paige.PagesPublic/MatchUrls";
  /** MatchUrls matches a list of URLs against page def patterns. */
  export function MatchUrls(sender: (req: MatchUrlsRequest, endpoint: string) => Promise<MatchUrlsReply>, req: MatchUrlsRequest): { promise: () => Promise<MatchUrlsReply>, endpoint: string } {
    return {
      promise: () => sender(req, MatchUrlsEndpoint),
      endpoint: MatchUrlsEndpoint
    };
  }

  export const SetManyEndpoint = "/grpc/paige.PagesPublic/SetMany";
  export function SetMany(sender: (req: SetManyRequest, endpoint: string) => Promise<SetManyReply>, req: SetManyRequest): { promise: () => Promise<SetManyReply>, endpoint: string } {
    return {
      promise: () => sender(req, SetManyEndpoint),
      endpoint: SetManyEndpoint
    };
  }
}

/** GetAllRequest requests all page definitions for the given org. */
export interface GetAllRequest {
  orgId: string;
  userDefinedPages: GetAllRequest.Filter;
  learnedPages: GetAllRequest.Filter;
  includeSuggested: boolean;
}

/** GetAllRequest requests all page definitions for the given org. */
export namespace GetAllRequest {
  export enum Filter {
    ALL = 0,
    NONE = 1,
    ACTIVE_ONLY = 2,
    ARCHIVED_ONLY = 3
  }
}

/** GetAllReply returns all page definitions found for the given org. */
export interface GetAllReply {
  pages: pages.PageDefinition[];
  /** total number of ML pages allowed */
  learnedLimit: number;
  /** hard limit on the total number of pages */
  maxPages: number;
  /** current state of ML configuration */
  mlState: MLState;
  /** pending suggested pages */
  pendingSuggestedPages: pages.PageDefinition[];
}

/** GetRequest requests a specific page definition from the given org. */
export interface GetRequest {
  orgId: string;
  id: number;
}

/** GetReply returns the request page definition, if one was found. */
export interface GetReply {
  page: pages.PageDefinition | null;
}

/** SetRequest creates or modifies a single page definition. */
export interface SetRequest {
  orgId: string;
  page: pages.PageDefinition | null;
  /** If provided, updates the "archived" state to the provided value. */
  archived: boolean | null;
}

/**
 * SetReply returns the updated page definition, or any conflicts that prevented the request from succeeding.
 * The request is applied atomically; if there were any conflicts the entire change is rolled back.
 */
export interface SetReply {
  page: pages.PageDefinition | null;
  errors: ValidationError[];
}

/** ArchiveRequest specifies the page definition to be archived. */
export interface ArchiveRequest {
  orgId: string;
  id: number;
}

/** ArchiveReply returns the page definition that was archived. */
export interface ArchiveReply {
  /** TODO(dutton): include audit metadata */
  page: pages.PageDefinition | null;
}

export interface ArchiveMultiRequest {
  orgId: string;
  ids: number[];
}

export interface ArchiveMultiReply {
  archived: number[];
}

/** UnarchiveRequest specifies the page definition to be unarchived. */
export interface UnarchiveRequest {
  orgId: string;
  id: number;
}

/**
 * UnarchiveReply returns the unarchived page definition. It may fail if the archived definition conflicts with
 * rules from a newer page definition. The returned page can still be Set to resolve any conflicts.
 */
export interface UnarchiveReply {
  page: pages.PageDefinition | null;
  errors: ValidationError[];
}

/** MatchRequest specifies the URLs and API-driven pageNames to be matched against the org's page definitions. */
export interface MatchRequest {
  orgId: string;
  urls: string[];
  platform: segment.NativePlatform;
  nonDestructive: boolean;
  pageNames: { [key: string]: MatchRequest.Urls };
}

/** MatchRequest specifies the URLs and API-driven pageNames to be matched against the org's page definitions. */
export namespace MatchRequest {
  /**
   * If the page name is archived, matches the fallback Urls instead. When that happens, they will be added to the
   * response as if they had been passed in the urls field instead, and the page_name will be omitted.
   * Protobuf does not support maps of lists, have to wrap in an extra type.
   */
  export interface Urls {
    urls: string[];
  }
}

/**
 * MatchReply returns a PageDefId for each unique URL / pageName given in the MatchRequest. If a URL or pageName does
 * not match any page definition, it will be included in the response with a PageDefId of 0 (indicating Not Defined).
 */
export interface MatchReply {
  /**
   * Deprecated in favor of url_matches
   * 
   * @deprecated
   */
  urls: { [key: string]: number };
  /**
   * The URL matches, with the original requested url as the key.
   * All URLs will be represented here, even those included as page name fallbacks.
   * This allows for all URLs to indicate their normalized value as well.
   */
  urlMatches: { [key: string]: MatchReply.UrlMatch };
  pageNames: { [key: string]: number };
}

/**
 * MatchReply returns a PageDefId for each unique URL / pageName given in the MatchRequest. If a URL or pageName does
 * not match any page definition, it will be included in the response with a PageDefId of 0 (indicating Not Defined).
 */
export namespace MatchReply {
  export interface UrlMatch {
    pageDefId: number;
    /**
     * The normalized URL for the match.
     * This always includes the provided host and path. If a fragment was supplied, it preserves that as well.
     * Query parameters may be removed or preserved based on underlying rules.
     */
    normalizedUrl: string;
  }
}

export interface AutocompleteRequest {
  orgId: string;
  scope: AutocompleteRequest.Scope;
  /** number of suggestions to return, 0 for unlimited */
  limit: protobuf.int64;
  /** restrict suggestions to this domain */
  domain: string;
  /** restrict suggestions to this path */
  path: string;
  /** restrict suggestions to this fragment */
  fragment: string;
}

export namespace AutocompleteRequest {
  export enum Scope {
    SCOPE_UNKNOWN = 0,
    SCOPE_HOST = 1,
    SCOPE_PATH = 2,
    SCOPE_FRAGMENT = 3,
    SCOPE_PATH_FRAGMENT = 4
  }
}

export interface AutocompleteReply {
  suggestions: string[];
}

export interface ComputeLearnedPages {
  orgId: string;
  /** Indicates whether the LearnedPages changes will be persisted to Datastore. */
  persistChanges: boolean;
  /** Indicates whether to save the response file as JSON in GCS bucket */
  saveResults: boolean;
}

export interface ValidationError {
  selfConflict?: SelfConflict | null;
  pattern?: PatternConflict | null;
  label?: LabelConflict | null;
  invalidPattern?: InvalidPattern | null;
  invalidLabel?: InvalidLabel | null;
  systemError?: SystemError | null;
}

export namespace ValidationError {
  export enum kind {
    selfConflict = 1,
    pattern = 2,
    label = 3,
    invalidPattern = 4,
    invalidLabel = 5,
    systemError = 6
  }

  export function kind_oneof(m: ValidationError): { opt: kind.invalidLabel, val: InvalidLabel } | { opt: kind.invalidPattern, val: InvalidPattern } | { opt: kind.label, val: LabelConflict } | { opt: kind.pattern, val: PatternConflict } | { opt: kind.selfConflict, val: SelfConflict } | { opt: kind.systemError, val: SystemError } | null {
    if (m.selfConflict != null) { return { opt: kind.selfConflict, val: m.selfConflict } }
    if (m.pattern != null) { return { opt: kind.pattern, val: m.pattern } }
    if (m.label != null) { return { opt: kind.label, val: m.label } }
    if (m.invalidPattern != null) { return { opt: kind.invalidPattern, val: m.invalidPattern } }
    if (m.invalidLabel != null) { return { opt: kind.invalidLabel, val: m.invalidLabel } }
    if (m.systemError != null) { return { opt: kind.systemError, val: m.systemError } }
    return null;
  }
}

export interface SelfConflict {
  id: number;
  patterns: pages.PatternRule[];
  indices: protobuf.int64[];
}

export interface PatternConflict {
  existingPage: number;
  existingPattern: pages.PatternRule | null;
  proposedPattern: pages.PatternRule | null;
}

export interface LabelConflict {
  existingPage: number;
  pageName: string;
}

export interface InvalidPattern {
  patternRule: pages.PatternRule | null;
  reason: InvalidPattern.Reason;
}

export namespace InvalidPattern {
  export enum Reason {
    /** Pattern is missing / empty. */
    MISSING_PATTERN = 0,
    /** Domain only supports double wildcard as first element. */
    DOMAIN_GLOB = 1,
    /** Path only supports double wildcard as last element. */
    PATH_GLOB = 2,
    /** Fragment only supports double wildcard as last element. */
    FRAGMENT_GLOB = 3,
    /** Query does not support double wildcard. */
    QUERY_GLOB = 16,
    /** Nested group is incorrect */
    NESTED_GROUP = 4,
    /** Pathname is incorrect */
    GLOB_IN_GROUP = 5,
    /** Wildcard is incorrect */
    WILDCARD_IN_GROUP = 6,
    /** There’s an error in one or more characters */
    INVALID_CHARACTER_GROUP = 7,
    /** This field must not be empty */
    EMPTY_LITERAL = 8,
    /** Nested group is incorrect */
    GROUP_IN_LITERAL = 9,
    /** Wildcard is incorrect */
    PARTIAL_WILDCARD = 10,
    /** Object structure is invalid */
    INVALID_STRUCTURE = 11,
    /** Duplicate in group */
    DUPLICATE_IN_GROUP = 12,
    /** Comma used as term */
    COMMA_IN_TERM = 13,
    /** Backslashes are not valid */
    INVALID_ESCAPE = 14,
    /** Question marks are not allowed in page patterns */
    QUESTION_MARK_IN_TERM = 15
  }
}

export interface InvalidLabel {
  reason: InvalidLabel.Reason;
  label: string;
}

export namespace InvalidLabel {
  export enum Reason {
    /** Labels cannot be empty */
    EMPTY_LABEL = 0
  }
}

export interface SystemError {
  reason: SystemError.Reason;
}

export namespace SystemError {
  export enum Reason {
    UNKNOWN_SYSTEM_ERROR = 0,
    EXCEEDED_PAGE_LIMIT = 1,
    BLOCKED_API_PAGE = 2
  }
}

export interface SearchRequest {
  orgId: string;
  searchString: string;
  includeArchived: boolean;
}

export interface SearchReply {
  nameMatches: number[];
  urlMatches: number[];
  labelMatches: number[];
}

export interface ListPagesRequest {
  orgId: string;
  pageInfo: pagination.PageInfoRequest | null;
  /** If non-zero, filters the response to just those modified since */
  modifiedSince: protobuf.timestamp | null;
  includeArchived: boolean;
}

export interface ListPagesResponse {
  pages: pages.PageDefinition[];
  pageInfo: pagination.PageInfoResponse | null;
}

export interface CaseConflictLogging {
  timestamp: protobuf.timestamp | null;
  orgId: string;
  query: string;
  sensitive: number;
  insensitive: number;
}

export enum MLState {
  UNSET = 0,
  LEARNING_ONLY = 1,
  ON = 2
}

export interface SetMLStateRequest {
  orgId: string;
  mlState: MLState;
}

/** MatchUrlsRequest specifies a list of URLs to match against provided page definitions. */
export interface MatchUrlsRequest {
  orgId: string;
  urls: string[];
  /** The page definitions to match URLs against. At least one page definition must be provided. */
  pageDefinitions: pages.PageDefinition[];
}

/** MatchUrlsReply returns the matching results for each URL. */
export interface MatchUrlsReply {
  /**
   * The URL matches, with the original requested url as the key.
   * This allows for all URLs to indicate their normalized value.
   */
  urlMatches: { [key: string]: MatchUrlsReply.UrlMatch };
}

/** MatchUrlsReply returns the matching results for each URL. */
export namespace MatchUrlsReply {
  export interface UrlMatch {
    matches: boolean;
    /**
     * The page definition that best matches this URL based on specificity rules.
     * Only set if matches is true.
     */
    bestMatchPage: pages.PageDefinition | null;
  }
}

/** ReservePageIdsRequest fetches and increments the next page id to be assigned. */
export interface ReservePageIdsRequest {
  orgId: string;
  /** count of how many ids to fetch/increment */
  count: number;
}

/** ReservePageIdsResponse returns the page ids that are now reserved */
export interface ReservePageIdsResponse {
  /** reserved ids */
  ids: number[];
}

/** SetManyRequest creates or modifies many page definitions. */
export interface SetManyRequest {
  orgId: string;
  pages: pages.PageDefinition[];
}

/**
 * SetManyReply returns the updated page definitions and any conflicts
 * Note that some pages can succeed while others fail due to conflicts
 */
export interface SetManyReply {
  pages: pages.PageDefinition[];
  errors: ValidationError[];
}
